import { render, staticRenderFns } from "./setActivityOne.vue?vue&type=template&id=5ca4fcab&scoped=true&"
import script from "./setActivityOne.vue?vue&type=script&lang=js&"
export * from "./setActivityOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca4fcab",
  null
  
)

export default component.exports